import Vue from 'vue';
import NavDropdown from "./components/NavDropdown"
import SAccordion from "./components/SAccordion"
import SBadge from "./components/SBadge"
import SButton from "./components/SButton"
import SDatePicker from "./components/SDatePicker"
import SCard from "./components/SCard"
import SCardHeader from "./components/SCardHeader"
import SCardSection from "./components/SCardSection"
import SCheckBox from "./components/SCheckBox"
import SInput from "./components/SInput"
import SNavButton from "./components/SNavButton"
import SSelect from "./components/SSelect"
import SSeparator from "./components/SSeparator"
import STab from "./components/STab"
import STabs from "./components/STabs"
import SToggle from "./components/SToggle"
import SSort from "./components/SSort"
import SPagination from "./components/SPagination"
import SMultiSelect from "./components/SMultiSelect"
import SFilePicker  from "./components/SFilePicker"
import SMore from "./components/SMore"
import SFileBox from "./components/SFileBox";
import MessageBox from "./components/MessageBox";
import MessageThread from "./components/MessageThread";
import Message from "./components/Message";
import SAvatar from "./components/SAvatar";
import SPillSeparator from "./components/SPillSeparator";
import SScrollView from "./components/SScrollView";
import STask from "./components/STask"
import SSwitch from "./components/SSwitch"
import SDialog from "./components/SDialog"
import SSlider from "./components/SSlider"
import SMultipleSelect from "./components/SMultipleSelect"
import STextarea from "./components/STextarea.vue"
import STagInput from "./components/STagInput";
import SMap from "./components/SMap";
import SStepper from "./components/SStepper.vue"
import SStep from "./components/SStep.vue"
import Sdt from "./components/Sdt.vue";
import HTMLBuilder from "./components/html-builder/HTMLBuilder.vue";
import Calendar from "./components/calendar/Calendar.vue";
import STooltip from "./components/STooltip.vue"
import SProgress from "./components/SProgress.vue";
import SSnackbar from "./components/SSnackbar.vue";
import SProgressLinear from "./components/SProgressLinear.vue";
import SWidget from "./components/SWidget.vue";
import STimePicker from './components/STimePicker.vue';
import SToast from './components/SToast.vue';
import SNotify from './components/SNotify.vue';
import AdvanceFilters from './components/AdvanceFilters.vue';
import SDateRange from './components/SDateRange.vue';
import SRadio from './components/SRadio.vue';
import SLoader from './components/SLoader.vue'

/*
  Global Registration of components
  to be share as a library
*/

const Components = {
    NavDropdown,
    SAccordion,
    SBadge,
    SButton,
    SDatePicker,
    SCard,
    SCardHeader,
    SCardSection,
    SCheckBox,
    SInput,
    SNavButton,
    SSelect,
    SSeparator,
    STab,
    STabs,
    SToggle,
    SSort,
    SPagination,
    SMultiSelect,
    SFilePicker,
    SMore,
    SFileBox,
    Message,
    MessageBox,
    MessageThread,
    SAvatar,
    SPillSeparator,
    SScrollView,
    STask,
    SSwitch,
    SDialog,
    SSlider,
    SMultipleSelect,
    STextarea,
    STagInput,
    SMap,
    SStepper,
    SStep,
    Sdt,
    HTMLBuilder,
    Calendar,
    STooltip,
    SProgress,
    SSnackbar,
    SProgressLinear,
    SWidget,
    STimePicker,
    SToast,
    SNotify,
    AdvanceFilters,
    SDateRange,
    SRadio,
    SLoader
};

Object.keys(Components).forEach(name => {
    Vue.component(name, Components[name]);
});

export default Components;
